import type { IconProps } from '@carboncopyco/icons';
import {
  ChangeDesignIcon,
  ClickIcon,
  DeleteOutlineIcon,
  DuplicateIcon,
  HideOutlineIcon,
  LinkOutlineIcon,
  PhotoSquareIcon,
  RestoreOutlineIcon,
  ShowOutlineIcon,
  TextOutlineIcon,
  TrendingOutlineIcon,
  UnClickIcon,
  VerticalAlignBottomIcon,
  VerticalAlignIcon,
} from '@carboncopyco/icons';
import type { IDynamicEditData } from '@carboncopyco/types';
import { IDynamicEditType } from '@carboncopyco/types';
import type React from 'react';

export const actionToIcon: Record<string, React.ReactElement<IconProps>> = {
  text: <TextOutlineIcon size={18} />,
  input: <TextOutlineIcon size={18} />,
  duplicate: <DuplicateIcon size={18} />,
  up: <VerticalAlignIcon size={18} />,
  down: <VerticalAlignBottomIcon size={18} />,
  delete: <DeleteOutlineIcon size={18} />,
  restore: <RestoreOutlineIcon size={18} />,
  chart: <TrendingOutlineIcon size={18} />,
  image: <PhotoSquareIcon size={18} />,
  style: <ChangeDesignIcon size={18} />,
  show: <ShowOutlineIcon size={18} />,
  hide: <HideOutlineIcon size={18} />,
  link: <LinkOutlineIcon size={18} />,
  lock: <ClickIcon size={18} />,
  unlock: <UnClickIcon size={18} />,
};

export const getActionToIcon = ({
  type,
  element,
}: IDynamicEditData): string => {
  const {
    new: { serialized, value },
  } = element;
  const actions = {
    [IDynamicEditType.list]: serialized?.moveType,
    [IDynamicEditType.visibility]: value === 'true' ? 'hide' : 'show',
    [IDynamicEditType.delete]: value === 'true' ? 'delete' : 'restore',
    [IDynamicEditType.lock]: value === 'true' ? 'lock' : 'unlock',
  };

  return actions[type] || type;
};
